import React, { Component } from 'react'
import '../assets/css/achieveAboard.css'
import { Input, Button, Select, Table, Pagination, message } from 'antd'
import { getAchieveAboard } from '../api'
const { Option } = Select

class AchieveList extends Component {
    constructor () {
        super()
        this.state = {
            searchInfo: {
                fundName: '',
                superviseName: '',
                fundType: ''
            },
            typeList: [
                { title: '全部', value: '' },
                { title: '公募基金', value: '0' },
                { title: '专户', value: '1' },
                { title: '私募基金', value: '2' },
                { title: '券商理财', value: '3' },
                { title: '期货资管', value: '4' },
                { title: '期货资管（一对多）', value: '5' },
                { title: '其他', value: '6' },
            ],
            fundStatusList: [
                { title: '认购期', value: '0' },
                { title: '存续期', value: '1' },
                { title: '存续期', value: '3' },
                { title: '存续期', value: '4' },
                { title: '存续期', value: '5' },
                { title: '基金终止', value: '6' },
                { title: '发行失败', value: '9' },
                { title: '准备期', value: '*' }
            ],
            tableInfo: {
                columns: [
                    { 
                        title: '产品名称',
                        dataIndex: 'fundName',
                        align: 'center'
                    },
                    { 
                        title: '管理人',
                        dataIndex: 'superviseName',
                        align: 'center'
                    },
                    { 
                        title: '产品类型',
                        dataIndex: 'fundType',
                        align: 'center',
                        render: (text) => {
                            let target = this.state.typeList.find(item => item.value === text)
                            let title = target ? target.title : ''
                            return title
                        }
                    },{ 
                        title: '净值日期',
                        dataIndex: 'noticeDate',
                        align: 'center'
                    },
                    { 
                        title: '运行状态',
                        dataIndex: 'fundStatus',
                        align: 'center',
                        render: (text) => {
                            let target = this.state.fundStatusList.find(item => item.value === `${text}`)
                            let title = target ? target.title : ''
                            return title
                        }
                    },
                    { 
                        title: '单位净值',
                        dataIndex: 'navValue',
                        align: 'center',
                        render: (text, row) => {
                            if (text === null) return null
                            return Number(text).toFixed(+row.navLength)
                        }
                    },
                    { 
                        title: '累计单位净值',
                        dataIndex: 'totalNavValue',
                        align: 'center',
                        render: (text, row) => {
                            if (text === null) return null
                            return Number(text).toFixed(+row.navLength)
                        }
                    }
                ],
                data: []
            },
            pageInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            }
        }
    }

    // 查询
    handleSearch = (value) => {
        if (value === undefined) {
            return this.getAchieveAboard()
        }
        this.setState({
            searchInfo: { ...this.state.searchInfo, fundType: value}
        }, () => {
            this.getAchieveAboard()
        })
    }

     // 页码改变
     handleCurrentChange = (page) => {
        this.setState({
            pageInfo: {...this.state.pageInfo, pageNo: page}
        }, () => {
            this.getAchieveAboard()
        })
    }

    // 获取业绩列表
    getAchieveAboard () {
        const params = {...this.state.searchInfo, ...this.state.pageInfo}
        getAchieveAboard(params).then(res => {
            if (res.code === 'Success') {
                const tableData = res.returnObject.data.map(item => {
                    return {
                        ...item,
                        key: item.fundCode
                    }
                })
                this.setState({
                    tableInfo: {...this.state.tableInfo, data: tableData},
                    pageInfo: {...this.state.pageInfo, total: tableData.length}
                })
            }else if (res.code === 'User.NotLogin') {
                this.props.history.push({
                    pathname: '/achieveAboard'
                })

            }else if (res.code === 'Error') {
                message.error(res.message)
            }
        }).catch(err => {
            message.error(err.message)
        })
    }

    componentDidMount () {
        this.getAchieveAboard()        
    }

    render() { 
        const { searchInfo, typeList, pageInfo } = this.state
        const { columns, data } = this.state.tableInfo
        return (
            <div>
                <div className="page-content-achieve-list l-container">
                    <div className="search-items">
                        <div className="search-item">
                            <span>产品名称：</span><Input width="200" height="36" onChange={e => searchInfo.fundName = e.target.value} />
                        </div>
                        <div className="search-item">
                            <span>管理人：</span><Input width="200" height="36" onChange={e => searchInfo.superviseName = e.target.value} />
                        </div>
                        <div className="search-item">
                            <Button onClick={() => this.handleSearch()}>查询</Button>
                        </div>
                        <div className="search-item">
                            <span>产品类型过滤:</span>
                            <Select defaultValue='' style={{width:230, height:36}} onChange={value => this.handleSearch(value)}>
                                {
                                    typeList.map(item => {
                                        return <Option key={item.value} value={item.value}>{item.title}</Option>
                                    })
                                }
                            </Select>
                        </div>
                    </div>  
                    <div className="search-table">
                        <Table columns={ columns } dataSource={ data } pagination={false}></Table>
                        {
                            pageInfo.total > 0 && <Pagination current={pageInfo.pageNo} pageSize={pageInfo.pageSize} total={pageInfo.total} onChange={(page) => this.handleCurrentChange(page)}/>
                        }
                    </div>  
                </div>
            </div>
        )
    }
}
 
export default AchieveList